<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      升级处理
    </p>
    <div class="search">
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
    <PicsModal
      :pics="picList"
      :visible="picModel"
      :index="picIndex"
      @on-close="picModel = false"
    />
  </Card>
 </div>
</template>

<script>
import { mapState } from 'vuex'

import PicsModal from '@/components/PicsModal'

export default {
  components: {
    PicsModal
  },
  data () {
    return {
      editModal: false,
      urlImg: '',
      picModel: false,
      picList: [],
      picIndex: 0,
      // emptyORderTime: ['', ''],
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: []
      // searchForm: {
      //   agent_name: '',
      //   title: '',
      //   // balance_state: '',
      //   invoice_no: '',
      //   logistics_no: '',
      //   flow_no: '',
      //   balance_start_time: '',
      //   balance_end_time: ''
      // },
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 100,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let setBtn = h('Poptip', {
              props: {
                confirm: true,
                title: '确认升级该代理商吗？',
                width: 160,
                transfer: true
              },
              on: {
                'on-ok': () => {
                  this.$http.put('/agent/account/update/handle', {id: row.id}).then(res => {
                    if (res.success) {
                      this.$Message.success('升级成功')
                      this.loadList()
                    }
                  })
                }
              }
            }, [
              h('Button', {
                props: {
                  type: 'ghost',
                  size: 'small'
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['升级'])
            ])
            return h('span', [
              setBtn
            ])
          }
        },
        {
          title: '代理商',
          key: 'agent_name',
          width: 180
        },
        {
          title: '升级等级',
          width: 140,
          render: (h, {row}) => {
            let priority = row.agent_level
            let priorityName = ''
            if (priority === 1) {
              priorityName = '升级铜牌'
            } else if (priority === 2) {
              priorityName = '升级银牌'
            } else if (priority === 3) {
              priorityName = '升级金牌'
            }
            return h('span', [priorityName])
          }
        },
        {
          title: '升级金额',
          key: 'price',
          width: 140
        },
        {
          title: '开户行',
          key: 'bank_name',
          width: 140
        },
        {
          title: '对公账号',
          key: 'bank_account',
          width: 140
        },
        {
          title: '流水单号',
          key: 'flow_no',
          width: 140
        },
        {
          title: '付款凭证图片',
          width: 140,
          ellipsis: true,
          render: (h, {row}) => {
            let check = h('a', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.picIndex = 0
                  this.picModel = true
                  this.urlImg = row.img_urls ? row.img_urls : ''
                  this.showPicList()
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['查看图片'])
            return ('span', [check])
          }
        },
        {
          title: '操作时间',
          key: 'create_time',
          width: 180
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/agent/account/recharge/list', {
          params: {
            type: 2,
            handle_state: 1,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/agent/account/recharge/count', {
          params: {
            handle_state: 1,
            type: 2,
            params: this.searchForm
          }
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    showPicList () {
      let arrImg = this.urlImg
      let arr = arrImg.split(',')
      this.picList = []
      if (arr.length !== 0) {
        arr.forEach((item) => {
          this.picList.push(item)
        })
      }
      this.picModel = true
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    // daterangeChange (daterange, start, end) {
    //   if (daterange[0]) {
    //     this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
    //     this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
    //   } else {
    //     this.searchForm[start] = ''
    //     this.searchForm[end] = ''
    //   }
    //   this.emptyORderTime = [this.searchForm[start], this.searchForm[end]]
    // },
    // 重置搜索框
    // resetSearchForm () {
    //   this.emptyORderTime = ['', '']
    //   this.searchForm = {
    //     agent_name: '',
    //     title: '',
    //     // balance_state: '',
    //     invoice_no: '',
    //     logistics_no: '',
    //     flow_no: '',
    //     balance_start_time: '',
    //     balance_end_time: ''
    //   }
    //   this.loadList()
    // },
    editReport () {
      this.editReportCurstom = true
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/upgradeHandle/index.vue